module.exports = __webpack_public_path__ + "static/media/GM.41da3da3.svg";